(function(){
  var API = 'https://furnace-direct-reps.vercel.app/api/contact-form';
  var brand = (document.body.getAttribute('data-brand') || 'fd').toLowerCase();
  var brandPhone = brand === 'cd' ? '(239) 544-4114' : '(888) 762-1334';

  var wrap = document.createElement('div');
  wrap.id = 'fd-cw';
  wrap.innerHTML =
    '<style>' +
    '#fd-cw-btn{position:fixed;bottom:20px;right:20px;z-index:99999;width:56px;height:56px;border-radius:50%;background:#E67E22;color:#fff;border:none;cursor:pointer;box-shadow:0 4px 14px rgba(230,126,34,.45);display:flex;align-items:center;justify-content:center;transition:transform .2s}' +
    '#fd-cw-btn:hover{transform:scale(1.08);background:#CF6D17}' +
    '#fd-cw-btn svg{width:28px;height:28px;fill:currentColor}' +
    '#fd-cw-panel{position:fixed;bottom:88px;right:20px;z-index:99999;width:320px;max-width:calc(100vw - 40px);background:#fff;border-radius:12px;box-shadow:0 8px 30px rgba(0,0,0,.18);display:none;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;max-height:calc(100vh - 110px);overflow-y:auto}' +
    '#fd-cw-panel.open{display:block}' +
    '#fd-cw-hd{background:#E67E22;color:#fff;padding:16px;font-size:16px;font-weight:600}' +
    '#fd-cw-form{padding:16px}' +
    '#fd-cw-form label{display:block;font-size:13px;font-weight:500;color:#374151;margin-bottom:4px}' +
    '#fd-cw-form input,#fd-cw-form select,#fd-cw-form textarea{width:100%;box-sizing:border-box;padding:10px 12px;border:1px solid #D1D5DB;border-radius:8px;font-size:15px;margin-bottom:12px;font-family:inherit;outline:none;transition:border .15s;background:#fff}' +
    '#fd-cw-form input:focus,#fd-cw-form select:focus,#fd-cw-form textarea:focus{border-color:#E67E22}' +
    '#fd-cw-form textarea{resize:none;height:60px}' +
    '#fd-cw-submit{width:100%;padding:12px;background:#E67E22;color:#fff;border:none;border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;transition:background .15s}' +
    '#fd-cw-submit:hover{background:#CF6D17}' +
    '#fd-cw-submit:disabled{opacity:.6;cursor:default}' +
    '#fd-cw-err{color:#DC2626;font-size:13px;margin-bottom:8px;display:none}' +
    '#fd-cw-ok{padding:24px 16px;text-align:center;display:none}' +
    '#fd-cw-ok h3{margin:0 0 8px;font-size:18px;color:#111}' +
    '#fd-cw-ok p{margin:0;font-size:14px;color:#6B7280}' +
    '.fd-cw-hp{position:absolute;left:-9999px;opacity:0;height:0;width:0}' +
    '</style>' +
    '<button id="fd-cw-btn" aria-label="Contact us"><svg viewBox="0 0 24 24"><path d="M20 2H4a2 2 0 0 0-2 2v18l4-4h14a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 14H5.17L4 17.17V4h16v12z"/><path d="M7 9h2v2H7zm4 0h2v2h-2zm4 0h2v2h-2z"/></svg></button>' +
    '<div id="fd-cw-panel">' +
      '<div id="fd-cw-hd">Get a callback</div>' +
      '<form id="fd-cw-form" novalidate>' +
        '<label for="fd-cw-name">Name</label>' +
        '<input id="fd-cw-name" name="name" type="text" autocomplete="name" required placeholder="Your name">' +
        '<label for="fd-cw-phone">Phone number</label>' +
        '<input id="fd-cw-phone" name="phone" type="tel" autocomplete="tel" required placeholder="(555) 123-4567">' +
        '<label for="fd-cw-zip">Zip code</label>' +
        '<input id="fd-cw-zip" name="zip" type="text" inputmode="numeric" autocomplete="postal-code" placeholder="55401" maxlength="5" required>' +
        '<label for="fd-cw-reason">Reason for inquiry</label>' +
        '<select id="fd-cw-reason" name="reason">' +
          '<option value="">Select one...</option>' +
          '<option value="New install">New install</option>' +
          '<option value="Equipment only (shipping)">Equipment only (shipping)</option>' +
          '<option value="Repair/service parts">Repair/service parts</option>' +
          '<option value="Get a quote">Get a quote</option>' +
          '<option value="Other">Other</option>' +
        '</select>' +
        '<label for="fd-cw-msg">What do you need?</label>' +
        '<textarea id="fd-cw-msg" name="message" required maxlength="500" placeholder="Tell us about your home and what you need"></textarea>' +
        '<input class="fd-cw-hp" name="_hp" type="text" tabindex="-1" autocomplete="off">' +
        '<div id="fd-cw-err"></div>' +
        '<button id="fd-cw-submit" type="submit">Request a call</button>' +
      '</form>' +
      '<div id="fd-cw-ok"><h3>We got your info</h3><p>We\'ll call you back shortly.<br>Or call us now at ' + brandPhone + '</p></div>' +
    '</div>';

  document.body.appendChild(wrap);

  var btn = document.getElementById('fd-cw-btn');
  var panel = document.getElementById('fd-cw-panel');
  var form = document.getElementById('fd-cw-form');
  var errEl = document.getElementById('fd-cw-err');
  var okEl = document.getElementById('fd-cw-ok');
  var submitBtn = document.getElementById('fd-cw-submit');

  btn.addEventListener('click', function(e){
    e.stopPropagation();
    panel.classList.toggle('open');
  });

  panel.addEventListener('click', function(e){
    e.stopPropagation();
  });

  document.addEventListener('click', function(){
    panel.classList.remove('open');
  });

  var HINTS = {
    'New install': 'e.g. 20-year-old gas furnace and AC, 2,000 sq ft house, want both replaced',
    'Equipment only (shipping)': 'e.g. 3 ton AC condenser and coil, shipped to my address',
    'Repair/service parts': 'Brand and model number of your unit, and the part you need',
    'Get a quote': 'What you have now, home size, and what you want quoted',
    'Other': 'Tell us what you need'
  };
  form.reason.addEventListener('change', function(){
    form.message.placeholder = HINTS[form.reason.value] || 'Tell us about your home and what you need';
  });

  function showErr(msg){ errEl.textContent = msg; errEl.style.display = 'block'; }
  function hideErr(){ errEl.style.display = 'none'; }

  form.addEventListener('submit', function(e){
    e.preventDefault();
    hideErr();

    var name = form.name.value.trim();
    var phone = form.phone.value.replace(/\D/g,'');
    var zip = form.zip.value.replace(/\D/g,'');
    var reason = form.reason.value;
    var message = form.message.value.trim();
    var hp = form._hp.value;

    if (phone.length === 11 && phone[0] === '1') phone = phone.slice(1);
    if (!name || name.length < 2){ showErr('Please enter your name.'); return; }
    if (phone.length !== 10){ showErr('Please enter a valid 10-digit phone number.'); return; }
    if (zip.length !== 5){ showErr('Please enter your 5-digit zip code.'); return; }
    if (!reason){ showErr('Please pick a reason for your inquiry.'); return; }
    if (message.length < 15){ showErr('Please tell us a little more about what you need.'); form.message.focus(); return; }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';

    var xhr = new XMLHttpRequest();
    xhr.open('POST', API);
    xhr.setRequestHeader('Content-Type','application/json');
    xhr.onload = function(){
      if (xhr.status === 200){
        form.style.display = 'none';
        okEl.style.display = 'block';
      } else {
        var msg = 'Something went wrong. Please call us at ' + brandPhone + '.';
        try { msg = JSON.parse(xhr.responseText).error || msg; } catch(x){}
        showErr(msg);
        submitBtn.disabled = false;
        submitBtn.textContent = 'Request a call';
      }
    };
    xhr.onerror = function(){
      showErr('Network error. Please call us at ' + brandPhone + '.');
      submitBtn.disabled = false;
      submitBtn.textContent = 'Request a call';
    };
    xhr.send(JSON.stringify({
      name: name,
      phone: phone,
      zip: zip,
      reason: reason,
      message: message,
      v: 2,
      _hp: hp,
      brand: brand,
      pageUrl: location.href
    }));
  });
})();
